<template>
  <div
    class="myPayments no-product-section subOrderList"
    :class="{ 'no-product-section': noResultFound }" style="padding:15px 0"
  >
    <div v-if="allPayments.length" class="my-sub-order">
      <div class="pay-amount">
        <p class="will-pay">
          Mall91 will Pay :
          <strong>Rs. {{ parseFloat(paymentObject.mall91WillPayAmount) }}.0</strong>
        </p>
        <p class="paid">
          You will pay to Mall91 :
          <strong>Rs. {{ parseFloat(paymentObject.sellerWillPayAmount) }}.0</strong>
        </p>
      </div>
       
      <span class="select-all" @click="selectAllUnsettledOrder()" v-if="selectAllUnsettled">
      <!-- <span class="material-icons">check_box_outline_blank</span> -->
      Select All</span>
      <span class="select-all" @click="unSelectAllUnsettledOrder()" v-if="unSelectAllUnsettled">
      <!-- <span class="material-icons">check_box</span> -->
      Select All</span>
      <ul class="payment-list">
        <li v-for="(item, index) in allPayments" :key="index">
          <!-- <li> -->
          <div
            class="payment-card"
            @click="viewPaymentDetail(index, item.id, item.paymentRefundStatus)"
          >
          
            <!-- <div class="date-detail"> -->
            <div class="date-detail" :class="{'paddingLeft' : item.status !== 'PENDING'}">
            <label>
              <input
                type="checkbox"
                :value="item.id"
                v-model="checkedPaymentIds"
                v-if="item.status === 'PENDING'"
              />
              <span class="checkmark" v-if="item.status === 'PENDING'" />
              <div class="flx">
                <p class="order-id" v-if="item.orderId">OrderID: #{{item.orderId}}</p>
                <p>{{ item.displayDate }}</p>
                <p
                  class="amount-detail"
                  v-if="item.status === 'SETTLED'"
                  style="color: green"
                >
                  Rs. {{ parseFloat(item.amount) }}.0
                </p>
                <p
                  class="amount-detail"
                  v-else-if="item.status === 'PROCESSING'"
                  style="color: blue"
                >
                  Rs. {{ parseFloat(item.amount) }}.0
                </p>
                <p class="amount-detail" v-else>
                  Rs. {{ parseFloat(item.amount) }}.0
                </p>
              </div>
              <div class="flx">
                <span style="margin-top: 2px;">{{item.itemName}}</span>
              </div>
              <div v-if="item.action === 'CREDIT'">
                <div class="flx" v-if="item.status === 'SUCCESS'">
                  <span>Mall91 ने भुगतान किये</span>
                  <!-- <span class="view-detail">View Details</span> -->
                </div>
                
                <div
                  class="flx"
                  v-else-if="item.status === 'PROCESSING'"
                >
                  <span
                    >आपका पेमेंट डिले हो रहा है , चिंता ना करें । 100% Mall91 पेमेंट गारंटी है ।<br />
                    <div class="svg_loader"><ProgressBarIcon /></div
                  ></span>
                  <!-- <span class="view-detail">View Details</span> -->
                </div>
                <div v-else-if="item.status === 'FAILED'">
                  <div class="flx">
                    <span>Mall91 have to pay you </span>
                    <!-- <span class="view-detail">View Details</span> -->
                  </div>
                  <div class="flx retry-option">
                    <p style="color: red">{{ item.failureReason }}</p>
                    <!-- <span
                      class="retry"
                      style="margin: 0"
                      @click.stop="retryRequest(item.parentId, item.id)"
                      >Retry</span
                    > -->
                  </div>
                </div>
                <div v-else>
                  <div class="flx">
                    <span>Mall91 have to pay you </span>
                    <!-- <span class="view-detail">View Details</span> -->
                  </div>
                </div>
              </div>
              <div v-else-if="item.action === 'DEBIT'">
                <div class="flx" v-if="item.status === 'PENDING'">
                  <span>You have to pay Mall91</span>
                  <!-- <span class="view-detail">View Details</span> -->
                </div>
                <div v-else-if="item.status === 'SETTLED'">
                  <div class="flx">
                    <span style="color:green;    font-weight: 600;    display: flex;
    align-items: center;">You have paid <span class="material-icons" style="    margin: 0;
    font-size: 18px;
    color: green;
    border-radius: 50%;
    margin-left: 4px;">
check_circle
</span></span> 
<!-- <span style="color:green;font-weight: 600;
    text-align: center;" v-if="item.settlementDate">Commission settled date <br/>{{item.settlementDate.split('T')[0]}}</span>
 <span style="color:green;    font-weight: 600;
    text-align: center;" v-if="item.settlementAmount">Commission amount <br/>Rs.{{Number(item.settlementAmount).toFixed(1)}}</span>                     -->
                    <span class="view-detail" @click="openSettledDetail($event,index)" v-if="item.settlementDate" style="width:auto;padding:0;display: flex;align-items: center;">Commission Settled <i class="material-icons" style="margin-left: 6px;font-size: 18px;">visibility</i></span>
                    <div class="customModal" v-if="isPaymentSettledBoolean === index">
                    <div class="modal_dialog Cod" style="padding:0">
                      <div class="modal_content" style="padding:15px">
                        <div class="modal_body padding0">
                          <p style="margin-bottom:8px"><Strong> Settled date</Strong>&nbsp;: {{item.settlementDate.split('T')[0]}}</p>
                          <p v-if="parseFloat(item.settlementAmount)>0"><strong> Amount</strong>&nbsp;: {{Number(item.settlementAmount).toFixed(1)}}</p>
                        </div>
                      </div>
                      <div class="modal_footer cod">
                        <button
                          type="button"
                          class="order_btn single"
                          @click="isPaymentSettledBoolean = !isPaymentSettledBoolean"
                        >{{$t('okText')}}</button>
                      </div>
                    </div>
                  </div>
                  </div>
                  <!-- <div class="flx retry-option">
                    <p style="color: red">{{ item.failureReason }}</p>
                    <span
                      class="retry"
                      style="margin: 0"
                      @click.stop="retryRequest(item.parentId, item.id)"
                      >Retry</span
                    >
                  </div> -->
                </div>
              </div>
              <div class="flx" v-else>
                <span>Mall91 have to pay you</span>
                <!-- <span class="view-detail">View Details</span> -->
              </div>
            </label>
            </div>
          </div>
          <div
            class="modal-pagecnt shippingDetails"
            style="padding-top: 65px"
            v-if="showPaymentDetail === index"
            :class="{ open_modal: showPaymentDetail === index }"
          >
            <header class="fixed_Back_header flx">
              <div class="menu flx">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="16"
                  viewBox="0 0 20 16"
                  @click="closeTrack()"
                >
                  <g fill="#000" fill-rule="evenodd">
                    <path
                      d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
                    />
                    <path
                      d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
                    />
                  </g>
                </svg>
                <h3>Payment Status</h3>
              </div>
            </header>
            <div class="order-track-status" v-if="paymentTrackList">
            <p class="payment-detail flx">
                <span class="left-text">MRP price</span>
                <span class="right-text">MRP price</span>
            </p>
            <p class="payment-detail flx">
                <span class="left-text">MRP price</span>
                <span class="right-text">MRP price</span>
            </p>
            <p class="payment-detail flx">
                <span class="left-text">MRP price</span>
                <span class="right-text">MRP price</span>
            </p>
            <h3 style="padding: 15px 25px 0;">Payment Status</h3>
              <div class="order-state" style="    margin-top: 25px;">
              
                <div
                  class="instatus completed"
                  :class="{ failed: item.paymentRefundStatus === 'FAILED' }"
                  v-for="(orderState, index) in paymentTrackList"
                  :key="index"
                >
                  <h3>{{ orderState.statusMessage }}</h3>
                  <p>{{ orderState.time }}</p>
                  <span
                    class="check"
                    v-if="item.paymentRefundStatus === 'SUCCESS'"
                  ></span>
                  <span
                    class="cross"
                    v-if="item.paymentRefundStatus === 'FAILED'"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="delivered-ftr">
        <button type="button" class="action-btn widthfull" @click="isActiveDeliverPopUp = !isActiveDeliverPopUp" v-if="checkedPaymentIds.length >=1" style="color: #108805;border: 1px solid #108805;background: #fff;
        ">Pay Now</button>
      </div>
      <div class="bottomToUp" v-if="isActiveDeliverPopUp"></div>
      <div class="bottomToUp_content item-deliver" :class="{'activeBottomtoUp' : isActiveDeliverPopUp}" v-if="isActiveDeliverPopUp">
        <div class="price-details">
          <h2><span class="material-icons done">done</span> Pay Now</h2>
          <div class="custmr-pay-detail">
            <div class="flx">
              <p><span>You will Pay</span></p>
              <strong>₹{{getMallGrossAmount()}}</strong>
            </div>
          </div>
          <div class="dlvr-wrap">
            <button class="dlvr-button" @click="payNowFunc()">Pay Now</button>
          </div>
        </div>
        <span class="closePopUp" @click="isActiveDeliverPopUp =!isActiveDeliverPopUp">
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
            <path
              fill="#CDCDCD"
              fill-rule="nonzero"
              d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
              opacity=".675"
            />
          </svg>
        </span>
      </div>
    </div>
    <infinite-loading
      @infinite="getMall91PaymentsListing"
      spinner="circles"
      :class="{ visibilityHidden: noResultFound }"
      :identifier="resetIdentifier"
    >
      <template slot="no-more">{{ $t("noMoreRecord") }}</template>
    </infinite-loading>
    <div class="no-product" v-if="noLogFound">
      <div class="no-item-found">
        <div class="img-block">
          <img src="../../assets/images/ic_product_box.svg" />
        </div>
        <div class="details-block">
          <p>No Data Found</p>
        </div>
      </div>
    </div>
    <div class="no-product" v-if="noResultFound">    
      <div class="no-item-found"  style="    margin-top: 150px;">
        <div class="img-block">
          <img src="../../assets/images/ic_product_box.svg" />
        </div>
        <div class="details-block">
          <p>अभी तक आपका कोई भी रिकॉर्ड नहीं मिला है</p>
        </div>
      </div>
    </div>
    
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
  </div>
</template>

<script>
import "../../assets/css/order-history.scss";
import axios from "axios";
import constant from "../../utils/constant";
import InfiniteLoading from "vue-infinite-loading";
import CustomToaster from "../../components/Common/CustomToaster";
import ApiCaller from "../../utils/apicaller";
import ProgressBarIcon from "../../components/Icons/ProgressBarIcon";
import { getBase64Url } from "../../utils/helper";
import Vue from "vue";
export default {
  name: "MyShopTransaction",
  components: {
    InfiniteLoading,
    CustomToaster,
    ProgressBarIcon,
  },
  data() {
    return {
      allPayments: [],
      pageIndex: 0,
      isValidDetail: false,
      noResultFound: false,
      toasterData: {},
      limit: 20,
      isPaymentSettledBoolean:false,
      paymentModeList: [
        { name: "Paytm", value: "PAYTM" },
        { name: "Mall91 Wallet", value: "MALL91_WALLET" },
        { name: "Bank UPI", value: "BANK_UPI" },
      ],
      bankDetailsDTO: {
        paymentTransferMode: "MALL91_WALLET",
      },
      isBankDetails: false,
      addedBankDetails: false,
      noBankDetails: false,
      bankDetails: {},
      loading: false,
      paymentObject: {},
      resetIdentifier: +new Date(),
      timerId: null,
      showPaymentDetail: false,
      paymentTrackList: [],
      noLogFound: false,
      checkedPaymentIds: [],
      checkedSettlementIds: [],
      isActiveDeliverPopUp: false,
      selectAllUnsettled: false,
      unSelectAllUnsettled: false,
      
    };
  },
  computed: {
    selectedMallPayCodAmount() {
      return this.allPayments
        .filter((data) => this.checkedPaymentIds.includes(data.id))
        .reduce((acc, currentVal) => {
          return acc + Number(currentVal.amount);
        }, 0);
    },
  },
  methods: {
    openSettledDetail(event,index) {
      event.preventDefault();
      this.isPaymentSettledBoolean = index;
    },
    selectAllUnsettledOrder(){      
      this.checkedPaymentIds = []
      this.allPayments.forEach(order =>{
        if(order.status === "PENDING"){
          this.selectAllUnsettled = false;
          this.unSelectAllUnsettled = true
          this.checkedPaymentIds.push(order.id)
        }
      })
    },
    unSelectAllUnsettledOrder(){
      this.selectAllUnsettled = true;
      this.unSelectAllUnsettled = false
      this.checkedPaymentIds = []
    },
    payNowFunc(){
      this.loading = true
      const obj = {
          sellerToMall91PaymentIds: this.checkedPaymentIds
        };
      ApiCaller(constant.SELLER_MALL91_SERVICE_URL, "create-seller-to-mall91-payment", "post" ,obj)
          .then((data) => {
            if(data.data.orderLogId){
              window.location.href =  `https://localmall.mall91.com/api/v1/payment-service/cod-settlement/doPay/${data.data.orderLogId}`
            }else{
              this.loading = false
            }
          }).catch(err =>{
            this.loading = false
            console.log(err)
          })
    },
    getMallGrossAmount() {
      if (this.checkedSettlementIds.length) {
        return this.selectedMallPayCodAmount - this.getMallAmountBySettlementId();
      }
      return this.selectedMallPayCodAmount;
    },
    getMallAmountBySettlementId() {
      const finalObj = this.settlement.find((obj) => {
        return obj.id.toString().includes(this.checkedSettlementIds[0]);
      });
      return finalObj.amount;
    },
    viewPaymentDetail(index, id, status) {
      // if (status != null) {
      //   this.getPaymentStatusPerId(index, id);
      // }
    },
    retryRequest(parentId, id) {
      this.loading = true;
      let failId;
      if (parentId) {
        failId = parentId;
      } else {
        failId = id;
      }
      ApiCaller(constant.SELLER_PAYMENT_URL, "failed-payment-retry-v1", "post", {
        sellerPaymentSettlementId: failId,
      })
        .then((data) => {
          this.paymentInterval();
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          if (err.response.data.errorCodes[0] == "RETRY_LIMIT_EXCEEDED") {
            this.toasterData = {
              msg:
                "Your retry limit is exceeded for this payment. Please contact to support.",
              color: "#e51c24",
              iconName: "close",
            };
            this.isValidDetail = true;
          } else if (
            err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
            err.response.data.message ==
              "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
          ) {
            try {
              _JWT.refereshToken = (res) => {
                if (res != "fail") {
                  this.$cookie.set("JWT-TOKEN", res);
                  this.retryRequest(parentId, id);
                } else {
                  this.loading = false;
                }
              };
              JSBridgePlugin.refreshTokens("_JWT.refereshToken");
            } catch (err) {
              this.loading = false;
              console.log(err);
            }
          }else {
            this.toasterData = {
              msg: err.response.data.message,
              color: "#e51c24",
              iconName: "close",
            };
            this.isValidDetail = true;
          }
          console.log(err);
        });
    },
    closeTrack() {
      this.showPaymentDetail = !this.showPaymentDetail;
      this.paymentTrackList.length = 0;
      this.noLogFound = false;
    },
    getPaymentStatusPerId(index, id) {
      this.loading = true;
      ApiCaller(constant.USER_PAYMENT_LOG, "get-user-payment-logs/" + id, "get")
        .then((data) => {
          this.loading = false;
          this.paymentTrackList = data.data;
          this.showPaymentDetail = index;
          if (this.paymentTrackList.length) {
          } else {
            this.noLogFound = true;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getPaymentStatus() {
      ApiCaller(
        constant.LOCAL_SHOP_URL_ORDER,
        "get-check-order-payment-status",
        "get"
      ).then((data) => {
        // this.pageIndex = 0;
        // this.resetIdentifier +=1;
      });
    },
    getMall91PaymentsListing($state) {
      // this.noResultFound = true;
      //  $state && $state.complete();
      if (this.$cookie.get("X-Auth-Id") != null) {
        ApiCaller(
          constant.LOCAL_SHOP_URL_ORDER,
          "get-mall91-transaction-details/" + this.pageIndex,
          "get"
        )
          .then((data) => {
            if (this.pageIndex == 0) {
              this.paymentObject = data.data;
              this.allPayments = [];
            }
            if (
              data.data.sellerToMall91Payments &&
              data.data.sellerToMall91Payments.length > 0
            ) {
              // this.allPayments = [];
              this.allPayments.push(...data.data.sellerToMall91Payments);
              let inStockitem = this.allPayments.filter((it) => {
                return it.paymentRefundStatus === "PROCESSING";
              });
              this.pageIndex += 1;
              this.noResultFound = false;
              this.allPayments.forEach(order =>{
                  if(order.status === "PENDING"){
                    this.selectAllUnsettled = true;
                    this.unSelectAllUnsettled = false
                  }
                })
              $state && $state.loaded();
              if (inStockitem.length) {
                this.getPaymentStatus();
              } else {
                clearInterval(this.timerId);
              }
            } else {
              $state && $state.complete();
            }
            if (this.allPayments.length == 0) {
              this.noResultFound = true;
            }
          })
          .catch((err) => {
            if (
              err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
              err.response.data.message ==
                "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
            ) {
              try {
                _JWT.refereshToken = (res) => {
                  if (res != "fail") {
                    this.$cookie.set("JWT-TOKEN", res);
                    this.getMall91PaymentsListing($state);
                  } else {
                    this.loading = false;
                  }
                };
                JSBridgePlugin.refreshTokens("_JWT.refereshToken");
              } catch (err) {
                this.loading = false;
                console.log(err);
              }
            }
          });
      }
    },
    paymentInterval() {
      let count = 0;
      this.timerId = setInterval(() => {
        if (count < 10) {
          this.pageIndex = 0;
          this.allPayments = []
          this.getMall91PaymentsListing();
          // this.resetIdentifier +=1;
        } else {
          clearInterval(this.timerId);
        }
        count++;
      }, 5000);
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.select-all{
  display: flex;
    align-items: center;
  width: max-content;
  font-size: .75em;
  padding: 4px 8px;
  font-weight: 500;
  border-radius: 4px;
  background: #0275d8;
  border-color: #0275d8;
  // box-shadow: 2px 2px 4px 0 rgb(0 0 0 / 70%);
  // text-shadow: 2px 2px 5px rgb(0 0 0 / 50%);
  line-height: normal;
  color: #fff;
  margin-bottom: 8px;
  .material-icons{
    padding-right: 8px;
        font-size: 18px;
  }
}
.date-detail {
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    top: 0;
    left: 0;
  }

  input:checked ~ .checkmark:after {
    display: block;
    // background: #138808;
  }

  input:checked ~ .checkmark {
    border-color: #138808;
    background: #fff;
  }

  .checkmark {
    position: absolute;
    left: 0;
    background: #fff;
    border-radius: 100%;
    border: 1px solid #ddd;
    top: 50%;
    transform: translateY(-50%);
    width: 22px;
    height: 22px;
    margin-top:0 !important;

    &::after {
      // transform: translate(-50%, -50%);
      // left: 50%;
      // top: 50%;
      width: 9px;
      height: 14px;
      // border-radius: 100%;
      // background: #138808;
      -webkit-transition: all 0.5s ease;
      transition: all 0.5s ease;
      content: '';
      position: absolute;
      display: none;
      border-bottom: 4px solid #138808;
      border-right: 4px solid #138808;
      transform: rotate(45deg);
      left: 5px;
      top: 2px;
    }
  }
}
.action-btn.widthfull{
  width: 100%;
}
.date-detail{
  padding-left: 32px;
}
.paddingLeft{
    padding-left: 0;
}
.sidebar-menu {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 99;
  padding: 0 0 16px 0;
  transition: 0.5s;
  transform: translateX(-100%);
  padding-top: 65px;
  &.open-slide {
    transform: translateX(0);
  }
}
.shippingDetails .order-track-status{
    padding: 15px 0 15px 0;
    .payment-detail{
            box-shadow: 0px 2px 6px #0000003d;
            padding: 12px 8px;
            border-radius: 8px;
            margin: 8px 15px;
            .left-text{
                font-size: 0.875em;
            }
            .right-text{
                font-size: 0.875em;
                font-weight: 600;
            }
    }
}
.shippingDetails .order-track-status .order-state::before {
  border-left: 2px dashed orange;
  height: 82%;
}
.shippingDetails .order-track-status .order-state:after {
  border-left: 2px dashed #c5c5c5;
  height: 82%;
}
.shippingDetails .order-track-status .order-state .instatus.completed::before {
  background: orange;
  box-shadow: 0 0 0 1px orange;
}
.shippingDetails
  .order-track-status
  .order-state
  .instatus.completed:last-child
  .check {
  transform: rotate(45deg);
  height: 10px;
  width: 5px;
  border-bottom: 3px solid #fff;
  border-right: 3px solid #fff;
  display: block;
  position: absolute;
  top: 5px;
  left: 33px;
  z-index: 9;
}
.shippingDetails
  .order-track-status
  .order-state
  .instatus.completed:last-child
  .cross {
  &:after {
    position: absolute;
    content: "";
    display: block;
    width: 4px;
    height: 0px;
    border: solid #e00;
    border-width: 0 0px 12px 0;
    transform: rotate(45deg);
    left: 33px;
    top: 5px;
    z-index: 9;
  }
  &:before {
    position: absolute;
    content: "";
    display: block;
    width: 4px;
    height: 0px;
    border: solid #e00;
    border-width: 0 0px 12px 0;
    transform: rotate(-45deg);
    left: 33px;
    top: 5px;
    z-index: 9;
  }
}
.shippingDetails
  .order-track-status
  .order-state
  .instatus.completed:last-child::before {
  background: green;
  box-shadow: 0 0 0 1px green;
}
.shippingDetails
  .order-track-status
  .order-state
  .instatus.completed.failed:last-child::before {
  background: white;
  box-shadow: 0 0 0 1px red;
}
.track-result {
  width: 100%;
  display: block;
  text-align: center;
  .success {
    font-size: 4em;
    color: green;
  }
  .failed {
    font-size: 4em;
    color: red;
  }
}
.svg_loader {
  height: 20px;
  margin: 0px auto;
  width: 200px;
  overflow: hidden;
  position: relative;
}
.svg_loader svg {
  position: absolute;
  top: -85px;
  left: -20px;
}
.myPayments {
  &.no-product-section {
    height: calc(100vh - 95px);
  }
  padding: 15px 8px;
  .add-info {
    font-size: 0.875em;
    color: #505050;
    // position: relative;
    z-index: 9;
    .edit-section {
      background: #fff;
      box-shadow: 10px 9px 20px 0px rgba(0, 0, 0, 0.16);
      padding: 8px;
      border-radius: 10px;
      margin: 8px 0;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      p {
        margin-top: 8px;
        &:first-child {
          margin-top: 0;
        }
      }
      .material-icons {
        color: #0063d3;
      }
      strong {
        // color: #0063D3;
      }
    }
    .bank-status {
      margin-bottom: 8px;
      span {
        color: green;
        font-weight: 600;
      }
      .material-icons {
        background: green;
        color: white;
        border-radius: 50%;
        padding: 0px;
        font-size: 1em;
        padding: 4px;
        margin-left: 8px;
      }
    }
    .status-message {
      font-weight: 600;
    }
  }
  .title {
    font-size: 0.875em;
    font-weight: 600;
    margin-top: 8px;
    color: #0063d3;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 10px 9px 0 rgba(0, 0, 0, 0.22);
    background: #fff;
    padding: 8px;
    border-radius: 5px;
    z-index: 1;
    position: relative;
    // border-top-left-radius: 5px;
    // border-top-right-radius: 5px;
  }
}
.heading {
  color: #484848;
  font-size: 1em;
}
.pay-amount {
  display: flex;
  justify-content: space-between;
  font-size: 0.688em;
  color: #727272;
  padding: 8px 0;
  .will-pay {
    strong {
      color: #ff0000;
    }
  }
  .paid {
    strong {
      color: #138708;
    }
  }
}
.payment-list {
  box-shadow: 10px 9px 20px 0px rgba(0, 0, 0, 0.16);

  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background: #fff;
  .payment-card {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin: 0 15px;
    border-bottom: 1px solid #0000001f;
    padding: 8px 0;
    // padding-top:24px;
    position: relative;
    .order-id{
      // position: absolute;
      // top:8px;
      // left:8px;
      color: blue;
    }
    .date-detail {
      width: 100%;
      .flx {
        justify-content: space-between;
      }
      p {
        font-size: 0.75em;
        font-weight: 600;
      }
      span {
        color: #727272;
        font-size: 0.75em;
        margin-top: 8px;
        display: block;
      }
    }
    .view-detail {
      color: #0066ff !important;
      width: 60px;
      text-align: right;
      font-size: 0.938em;
      padding-top: 8px;
      display: block;
      white-space: nowrap;
      font-weight: 600;
    }
    .retry-option {
      background: #f1f1f1;
      border: 1px solid #ddd;
      margin-top: 8px;
      padding: 8px;
      border-radius: 5px;
      p {
        font-weight: 500;
      }
      span {
        color: #0066ff !important;
        font-weight: 600;
        width: 50px;
        height: 14px;
        text-align: right;
      }
    }
    .amount-detail {
      font-size: 0.75em;
      color: #ff0000;
      font-weight: 600;
      text-align: right;
      p {
      }
    }
  }
}
.tracking_details {
  padding: 0 0 15px 0;
  .tracking_info {
    // position: absolute;
    // width: 92%;
    padding: 6px 0;
    z-index: 1;
    position: relative;
  }
}

.selectTypepay {
  width: 100%;
  margin: 0px 0 10px 0;
  display: block;
  padding: 5px;
  border-radius: 5px;
  font-size: 0.875em;
  color: #000;
  border: 1px solid rgba(0, 0, 0, 0.4);
  // box-shadow: 10px 9px 20px 0px #0000001F;
}
.viewPortcnt {
  // position: absolute;
  background: #fff;
  // width: 92%;
  padding: 8px;
  box-shadow: 0 10px 9px 0 rgba(0, 0, 0, 0.22);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  margin-top: -4px;

  // padding-top: 8px;

  .payBackstatusbox {
    width: 100%;
    display: block;
    text-align: center;

    h3 {
      width: 100%;
      text-align: left;
      font-size: 4vw;
      font-weight: 500;
      padding: 10px 0 10px 0;
      margin: 0;
      color: #000000;
    }
    .inputtextbg {
      width: 96%;
      margin: 0px 0 10px 0;
      display: block;
      padding: 5px;
      border-radius: 5px;
      font-size: 0.875em;
      color: #000;
      border: 1px solid rgba(0, 0, 0, 0.4);
      text-align: left;
    }
  }
  .add-dtl-btn {
    background: #108805;
    color: #fff;
    padding: 8px;
    display: block;
    width: 50%;
    margin: 0 auto;
    text-align: center;
    border-radius: 25px;
  }
}
</style>
